// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","nav":"Header_nav__akIpU","logo":"Header_logo__G+ea6","tree":"Header_tree__xFCm0","navLinks":"Header_navLinks__MKIKY"};